/*!
 * Copyright (c) REWE Digital GmbH
 */
import { h, Host } from "@stencil/core";
/**
 * Container for animated multipages.
 */
export class VxAnimatedMultiPageContainer {
    constructor() {
        this.totalPages = undefined;
        this.currentPageNumber = 1;
    }
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        const pageShiftFactor = 100 / this.totalPages;
        const shiftValue = pageShiftFactor * (this.currentPageNumber - 1);
        return (h(Host, { key: '881ec16302b3b7a3d10dc7fa96190667b658c15c' }, h("div", { key: 'a57547760e9cdf9106a97fcf8401883dce8cae30', class: 'vx-animated-multi-page-container', style: {
                width: (100 * this.totalPages) + '%',
                transform: 'translateX(-' + shiftValue + '%)',
            } }, h("slot", { key: '5092e042d804a75ab7a939c7006e7a4842a5560b' }))));
    }
    static get is() { return "vx-animated-multi-page-container"; }
    static get encapsulation() { return "scoped"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-animated-multi-page-container.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-animated-multi-page-container.css"]
        };
    }
    static get properties() {
        return {
            "totalPages": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Total number of pages."
                },
                "attribute": "total-pages",
                "reflect": false
            },
            "currentPageNumber": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Current Page number."
                },
                "attribute": "current-page-number",
                "reflect": false,
                "defaultValue": "1"
            }
        };
    }
}
//# sourceMappingURL=vx-animated-multi-page-container.js.map
